import {defaultLocale, locales, overrideLocales} from '@i18n/config';

export function decodeLocale(locale: string): string | null {
	if (!locale) return null;
	return locale.replace(/_/g, '-');
}

export function isLocaleSupported(locale: string) {
	return locales.includes(locale);
}

export function transformLocale(locale: string): string | null {
	if (typeof locale !== 'string' || !locale.length) return null;
	const noSlashLocale = locale.replace(/\//g, '');
	const decodedLocale = decodeLocale(noSlashLocale) || defaultLocale;
	if (overrideLocales[decodedLocale]) {
		return decodeLocale(overrideLocales[decodedLocale]);
	}
	return decodedLocale;
}
